/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../../public/upgrade/feature/pointOfSale/edit/general-setting/general-setting.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../../public/upgrade/core/logger.service';
import * as import10 from '../../../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import11 from '../../../../shared/input-container/input-container.component.ngfactory';
import * as import12 from '@ngx-translate/core/src/translate.pipe';
import * as import13 from '@ngx-translate/core/src/translate.service';
export class Wrapper_GeneralSettingComponent {
  /*private*/ _eventHandler:Function;
  context:import0.GeneralSettingComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  /*private*/ _expr_3:any;
  /*private*/ _expr_4:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.GeneralSettingComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
    this._expr_3 = import1.UNINITIALIZED;
    this._expr_4 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  check_dto(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.dto = currValue;
      this._expr_0 = currValue;
    }
  }
  check_isEditing(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.isEditing = currValue;
      this._expr_1 = currValue;
    }
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._expr_2 = currValue;
    }
  }
  check_errorMessages(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_3,currValue))) {
      this._changed = true;
      this.context.errorMessages = currValue;
      this._expr_3 = currValue;
    }
  }
  check_data(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_4,currValue))) {
      this._changed = true;
      this.context.data = currValue;
      this._expr_4 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_GeneralSettingComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_GeneralSettingComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.GeneralSettingComponent>;
  _GeneralSettingComponent_0_3:Wrapper_GeneralSettingComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_GeneralSettingComponent_Host0,renderType_GeneralSettingComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'general-setting',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_GeneralSettingComponent0(this.viewUtils,this,0,this._el_0);
    this._GeneralSettingComponent_0_3 = new Wrapper_GeneralSettingComponent(this.injectorGet(import9.LoggerService,this.parentIndex));
    this.compView_0.create(this._GeneralSettingComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._GeneralSettingComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.GeneralSettingComponent) && (0 === requestNodeIndex))) { return this._GeneralSettingComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._GeneralSettingComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const GeneralSettingComponentNgFactory:import8.ComponentFactory<import0.GeneralSettingComponent> = new import8.ComponentFactory<import0.GeneralSettingComponent>('general-setting',View_GeneralSettingComponent_Host0,import0.GeneralSettingComponent);
const styles_GeneralSettingComponent:any[] = ([] as any[]);
var renderType_GeneralSettingComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_GeneralSettingComponent,{});
export class View_GeneralSettingComponent0 extends import2.AppView<import0.GeneralSettingComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  compView_15:import2.AppView<import10.InputContainerComponent>;
  _InputContainerComponent_15_3:import11.Wrapper_InputContainerComponent;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  compView_23:import2.AppView<import10.InputContainerComponent>;
  _InputContainerComponent_23_3:import11.Wrapper_InputContainerComponent;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _el_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _text_39:any;
  _text_40:any;
  _el_41:any;
  _text_42:any;
  _el_43:any;
  compView_43:import2.AppView<import10.InputContainerComponent>;
  _InputContainerComponent_43_3:import11.Wrapper_InputContainerComponent;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _text_47:any;
  _el_48:any;
  _text_49:any;
  _el_50:any;
  _el_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _text_55:any;
  _text_56:any;
  _el_57:any;
  _text_58:any;
  _el_59:any;
  compView_59:import2.AppView<import10.InputContainerComponent>;
  _InputContainerComponent_59_3:import11.Wrapper_InputContainerComponent;
  _text_60:any;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  /*private*/ _expr_72:any;
  _pipe_translate_0:import12.TranslatePipe;
  _pipe_translate_1:import12.TranslatePipe;
  _pipe_translate_2:import12.TranslatePipe;
  _pipe_translate_3:import12.TranslatePipe;
  _pipe_translate_4:import12.TranslatePipe;
  /*private*/ _expr_78:any;
  _pipe_translate_5:import12.TranslatePipe;
  /*private*/ _expr_80:any;
  _pipe_translate_6:import12.TranslatePipe;
  /*private*/ _expr_82:any;
  _pipe_translate_7:import12.TranslatePipe;
  _pipe_translate_8:import12.TranslatePipe;
  _pipe_translate_9:import12.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_GeneralSettingComponent0,renderType_GeneralSettingComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_72 = import1.UNINITIALIZED;
    this._expr_78 = import1.UNINITIALIZED;
    this._expr_80 = import1.UNINITIALIZED;
    this._expr_82 = import1.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n\n    ',(null as any));
    this._el_11 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_11,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._el_15 = import3.createRenderElement(this.renderer,this._el_13,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_15 = new import11.View_InputContainerComponent0(this.viewUtils,this,15,this._el_15);
    this._InputContainerComponent_15_3 = new import11.Wrapper_InputContainerComponent();
    this._text_16 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_15.create(this._InputContainerComponent_15_3.context);
    this._text_17 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_11,'div',new import3.InlineArray2(2,'class','-md-1 -sm-2 -eva-3-mt-lg -eva-3-pt-xlg'),(null as any));
    this._text_20 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_11,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n            ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_23 = new import11.View_InputContainerComponent0(this.viewUtils,this,23,this._el_23);
    this._InputContainerComponent_23_3 = new import11.Wrapper_InputContainerComponent();
    this._text_24 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_23.create(this._InputContainerComponent_23_3.context);
    this._text_25 = this.renderer.createText(this._el_21,'\n        ',(null as any));
    this._text_26 = this.renderer.createText(this._el_11,'\n    ',(null as any));
    this._text_27 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'\n\n        ',(null as any));
    this._el_30 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_31 = this.renderer.createText(this._el_30,'\n            ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','-md-2 -sm-2'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n                ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'',(null as any));
    this._text_36 = this.renderer.createText(this._el_32,'\n                ',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_32,'div',new import3.InlineArray2(2,'class','-h5 -eva-3-mt-lg'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'',(null as any));
    this._text_39 = this.renderer.createText(this._el_32,'\n            ',(null as any));
    this._text_40 = this.renderer.createText(this._el_30,'\n            ',(null as any));
    this._el_41 = import3.createRenderElement(this.renderer,this._el_30,'div',new import3.InlineArray2(2,'class','-lg-10 -md-10 -sm-10 -eva-3-mt-lg'),(null as any));
    this._text_42 = this.renderer.createText(this._el_41,'\n                ',(null as any));
    this._el_43 = import3.createRenderElement(this.renderer,this._el_41,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_43 = new import11.View_InputContainerComponent0(this.viewUtils,this,43,this._el_43);
    this._InputContainerComponent_43_3 = new import11.Wrapper_InputContainerComponent();
    this._text_44 = this.renderer.createText((null as any),'\n                ',(null as any));
    this.compView_43.create(this._InputContainerComponent_43_3.context);
    this._text_45 = this.renderer.createText(this._el_41,'\n            ',(null as any));
    this._text_46 = this.renderer.createText(this._el_30,'\n        ',(null as any));
    this._text_47 = this.renderer.createText(this._el_28,'\n        ',(null as any));
    this._el_48 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','-md-1 -sm-2 -eva-3-mt-lg'),(null as any));
    this._text_49 = this.renderer.createText(this._el_48,'\n                                ',(null as any));
    this._el_50 = import3.createRenderElement(this.renderer,this._el_48,'span',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_50,'i',new import3.InlineArray4(4,'class','eva-3-icon-info-circle','style','width: 32px;color: #2D72E1;font-size: 32px;'),(null as any));
    this._text_52 = this.renderer.createText(this._el_50,'\n                                    ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_50,'dsp-tooltip',new import3.InlineArray2(2,'size','sm'),(null as any));
    this._text_54 = this.renderer.createText(this._el_50,'\n                                ',(null as any));
    this._text_55 = this.renderer.createText(this._el_48,'\n        ',(null as any));
    this._text_56 = this.renderer.createText(this._el_28,'\n        ',(null as any));
    this._el_57 = import3.createRenderElement(this.renderer,this._el_28,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_58 = this.renderer.createText(this._el_57,'\n            ',(null as any));
    this._el_59 = import3.createRenderElement(this.renderer,this._el_57,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_59 = new import11.View_InputContainerComponent0(this.viewUtils,this,59,this._el_59);
    this._InputContainerComponent_59_3 = new import11.Wrapper_InputContainerComponent();
    this._text_60 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_59.create(this._InputContainerComponent_59_3.context);
    this._text_61 = this.renderer.createText(this._el_57,'\n        ',(null as any));
    this._text_62 = this.renderer.createText(this._el_28,'\n    ',(null as any));
    this._text_63 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_translate_0 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_15,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_15));
    this._InputContainerComponent_15_3.subscribe(this,this.eventHandler(this.handleEvent_15),false,false,true);
    this._pipe_translate_1 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_23,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_23));
    this._InputContainerComponent_23_3.subscribe(this,this.eventHandler(this.handleEvent_23),false,false,true);
    this._pipe_translate_3 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_43,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_43));
    this._InputContainerComponent_43_3.subscribe(this,this.eventHandler(this.handleEvent_43),false,false,true);
    this._pipe_translate_6 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_59,new import3.InlineArray2(2,'modelChange',(null as any)),this.eventHandler(this.handleEvent_59));
    this._InputContainerComponent_59_3.subscribe(this,this.eventHandler(this.handleEvent_59),false,false,true);
    this._pipe_translate_8 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import12.TranslatePipe(this.parentView.injectorGet(import13.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._el_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._text_39,
      this._text_40,
      this._el_41,
      this._text_42,
      this._el_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._text_47,
      this._el_48,
      this._text_49,
      this._el_50,
      this._el_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._text_55,
      this._text_56,
      this._el_57,
      this._text_58,
      this._el_59,
      this._text_60,
      this._text_61,
      this._text_62,
      this._text_63
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import10.InputContainerComponent) && ((15 <= requestNodeIndex) && (requestNodeIndex <= 16)))) { return this._InputContainerComponent_15_3.context; }
    if (((token === import10.InputContainerComponent) && ((23 <= requestNodeIndex) && (requestNodeIndex <= 24)))) { return this._InputContainerComponent_23_3.context; }
    if (((token === import10.InputContainerComponent) && ((43 <= requestNodeIndex) && (requestNodeIndex <= 44)))) { return this._InputContainerComponent_43_3.context; }
    if (((token === import10.InputContainerComponent) && ((59 <= requestNodeIndex) && (requestNodeIndex <= 60)))) { return this._InputContainerComponent_59_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_15_0_0:any = 'posName';
    this._InputContainerComponent_15_3.check_name(currVal_15_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_15_0_1:any = valUnwrapper.unwrap(this._pipe_translate_1.transform('pointOfSale.NAME'));
    this._InputContainerComponent_15_3.check_label(currVal_15_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_15_0_2:boolean = !!this.context.errors['posName'];
    this._InputContainerComponent_15_3.check_invalid(currVal_15_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_15_0_3:any = valUnwrapper.unwrap(this._pipe_translate_2.transform(this.context.errorMessages['posName']));
    this._InputContainerComponent_15_3.check_invalidText(currVal_15_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_15_0_4:any = this.context.dto.name;
    this._InputContainerComponent_15_3.check_model(currVal_15_0_4,throwOnChange,false);
    this._InputContainerComponent_15_3.ngDoCheck(this,this._el_15,throwOnChange);
    const currVal_23_0_0:any = 'posContact';
    this._InputContainerComponent_23_3.check_name(currVal_23_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_23_0_1:any = valUnwrapper.unwrap(this._pipe_translate_3.transform('pointOfSale.CONTACT_NAME'));
    this._InputContainerComponent_23_3.check_label(currVal_23_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_23_0_2:boolean = !!this.context.errors['posContact'];
    this._InputContainerComponent_23_3.check_invalid(currVal_23_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_23_0_3:any = valUnwrapper.unwrap(this._pipe_translate_4.transform(this.context.errorMessages['posContact']));
    this._InputContainerComponent_23_3.check_invalidText(currVal_23_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_23_0_4:any = this.context.dto.contact;
    this._InputContainerComponent_23_3.check_model(currVal_23_0_4,throwOnChange,false);
    this._InputContainerComponent_23_3.ngDoCheck(this,this._el_23,throwOnChange);
    const currVal_43_0_0:any = 'posPhone';
    this._InputContainerComponent_43_3.check_name(currVal_43_0_0,throwOnChange,false);
    const currVal_43_0_1:boolean = !!this.context.errors['posPhone'];
    this._InputContainerComponent_43_3.check_invalid(currVal_43_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_43_0_2:any = valUnwrapper.unwrap(this._pipe_translate_6.transform(this.context.errorMessages['posPhone']));
    this._InputContainerComponent_43_3.check_invalidText(currVal_43_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_43_0_3:any = this.context.dto.phone;
    this._InputContainerComponent_43_3.check_model(currVal_43_0_3,throwOnChange,false);
    this._InputContainerComponent_43_3.ngDoCheck(this,this._el_43,throwOnChange);
    const currVal_59_0_0:any = 'posMail';
    this._InputContainerComponent_59_3.check_name(currVal_59_0_0,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_59_0_1:any = valUnwrapper.unwrap(this._pipe_translate_8.transform('pointOfSale.EMAIL'));
    this._InputContainerComponent_59_3.check_label(currVal_59_0_1,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_59_0_2:boolean = !!this.context.errors['posMail'];
    this._InputContainerComponent_59_3.check_invalid(currVal_59_0_2,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_59_0_3:any = valUnwrapper.unwrap(this._pipe_translate_9.transform(this.context.errorMessages['posMail']));
    this._InputContainerComponent_59_3.check_invalidText(currVal_59_0_3,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_59_0_4:any = this.context.dto.email;
    this._InputContainerComponent_59_3.check_model(currVal_59_0_4,throwOnChange,false);
    this._InputContainerComponent_59_3.ngDoCheck(this,this._el_59,throwOnChange);
    valUnwrapper.reset();
    const currVal_72:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('pointOfSale.GENERAL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_72,currVal_72))) {
      this.renderer.setText(this._text_7,currVal_72);
      this._expr_72 = currVal_72;
    }
    valUnwrapper.reset();
    const currVal_78:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('pointOfSale.PHONE_NUMBER')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_78,currVal_78))) {
      this.renderer.setText(this._text_35,currVal_78);
      this._expr_78 = currVal_78;
    }
    const currVal_80:any = import3.inlineInterpolate(1,'',((this.context.data == null)? (null as any): this.context.data.phoneCode),'');
    if (import3.checkBinding(throwOnChange,this._expr_80,currVal_80)) {
      this.renderer.setText(this._text_38,currVal_80);
      this._expr_80 = currVal_80;
    }
    valUnwrapper.reset();
    const currVal_82:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('pointOfSale.PHONE_WARNING')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_82,currVal_82))) {
      this.renderer.setElementAttribute(this._el_53,'tooltip-text',((currVal_82 == null)? (null as any): currVal_82.toString()));
      this._expr_82 = currVal_82;
    }
    this.compView_15.internalDetectChanges(throwOnChange);
    this.compView_23.internalDetectChanges(throwOnChange);
    this.compView_43.internalDetectChanges(throwOnChange);
    this.compView_59.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_15_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_23_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_43_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_59_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this.compView_15.destroy();
    this.compView_23.destroy();
    this.compView_43.destroy();
    this.compView_59.destroy();
    this._InputContainerComponent_15_3.ngOnDestroy();
    this._InputContainerComponent_23_3.ngOnDestroy();
    this._InputContainerComponent_43_3.ngOnDestroy();
    this._InputContainerComponent_59_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
  }
  handleEvent_15(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.name = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_23(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.contact = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_43(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.phone = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_59(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.dto.email = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/pointOfSale/edit/general-setting/general-setting.component.ngfactory.ts